/**
 * Applies the admin's brand color app-wide by overriding the `--brand-*`
 * custom properties that `tailwind.config.js` points every `brand-*` class at.
 *
 * A rendered `<style>` rather than an imperative `setProperty` in an effect:
 * the web tests have no DOM and render components to an HTML string, so this
 * is the form that can actually be asserted. It sits in the document body,
 * after the stylesheet in `<head>`, so equal-specificity `:root` rules resolve
 * in its favor.
 */
import { useEffect, useState } from "react";
import { useSiteSettings } from "../lib/siteSettings";
import { brandThemeCss, readCachedBrandColor, writeCachedBrandColor } from "../lib/brandTheme";

export function BrandTheme() {
  const { data } = useSiteSettings();
  // Read once, on mount: later reads would fight the query's own answer.
  const [cached] = useState(readCachedBrandColor);

  useEffect(() => {
    if (data) writeCachedBrandColor(data.brandColor ?? null);
  }, [data]);

  // Before the query resolves, the last color we saw. After it resolves, the
  // server's answer — including null, which means an admin cleared it.
  const css = brandThemeCss(data ? data.brandColor : cached);
  return css ? <style data-brand-theme="">{css}</style> : null;
}
